module.exports = "/fonts/ElevanceSans-Medium.fbb0cec76f2b716c849290dc4dccadbe.eot";